import { createRouter, createWebHistory } from 'vue-router'
import { store } from "../store";
import { CONFIG } from "../config";

// load routes files
import authRoutes from '../modules/auth/routes';
import posRoutes from '../modules/pos/routes';

const routesCore = [
    /*{
        path: "/dashboard",
        component: Dashboard,
    },*/
];

const routes = routesCore.concat(authRoutes, posRoutes);

const router = createRouter({
    history: createWebHistory(),
    //base: process.env.BASE_URL,
    routes,
})

router.beforeEach((to, from, next) => {
    const isPublicRoute = to.matched.some(record => record.meta.isPublic);
    const isLoginClient = to.matched.some(record => record.meta.loginClient);

    const fullDomain = window.location.href;
    const parsedUrl = new URL(fullDomain);

    // domain with subdomain
    let domain = parsedUrl.host;

    if (!isPublicRoute) {
        // si tengo token, en teoria estoy logueado
        if (store.getters.AuthIsLogged) {

            // voy a validar si el token esta ok
            store.dispatch('AuthValidateToken', {
                callback: (data) => {
                    next();
                },
                routerGuard: next
            });
        }
        // si no tengo token, es que estoy deslogueado o esta corrupto, lo mando a loguearse
        else {
            // si va para el panel, osea que no es una tienda, lo forzo a login
            next('/login');
        }
    }
    else {
        next();
    }
});

export default router;
